import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ClipboardPaste } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";

// Autofill: when the user comes back from the mail app we silently read the clipboard and
// drop the 6 digits in. Keyboard autofill from email is Apple-Mail-only, this covers every app.
export const ArchiveCodeStep = ({ label, email, code, setCode, onResend, busy }) => {
  const { t } = useTranslation();
  const digits = code.replace(/\D/g, "").slice(0, 6);

  useEffect(() => {
    const grab = async () => {
      if (digits.length === 6 || document.hidden) return;
      const text = await navigator.clipboard?.readText().catch(() => "");
      const found = (text?.match(/\d{6}/) || [])[0];
      if (found) setCode(found);
    };
    grab();
    window.addEventListener("focus", grab);
    document.addEventListener("visibilitychange", grab);
    return () => {
      window.removeEventListener("focus", grab);
      document.removeEventListener("visibilitychange", grab);
    };
  }, [digits, setCode]);

  const paste = async () => {
    const text = await navigator.clipboard.readText().catch(() => "");
    const found = (text.match(/\d{6}/) || [])[0];
    if (found) setCode(found);
  };

  return (
    <div className="space-y-3 text-sm">
      <p className="text-muted-foreground">{t("archiveCompany.codeHint", { email })}</p>
      <NeuInput
        data-testid={`${label}-code`}
        autoFocus
        type="text"
        name="otp"
        autoComplete="one-time-code"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        value={digits}
        onChange={(e) => setCode(e.target.value)}
        onPaste={(e) => setCode((e.clipboardData.getData("text").match(/\d{6}/) || [""])[0])}
        placeholder="••••••"
        className="text-center text-2xl tracking-[0.6em] font-mono"
      />
      <div className="flex items-center justify-between">
        <button
          type="button"
          data-testid={`${label}-paste`}
          onClick={paste}
          className="flex items-center gap-1 text-xs font-bold text-primary"
        >
          <ClipboardPaste className="h-4 w-4" />
          {t("archiveCompany.paste")}
        </button>
        <button
          type="button"
          data-testid={`${label}-resend`}
          onClick={onResend}
          disabled={busy}
          className="text-xs text-primary underline underline-offset-2 disabled:opacity-50"
        >
          {t("archiveCompany.resend")}
        </button>
      </div>
    </div>
  );
};
